export default __webpack_public_path__ + "static/09_Monkey-8185d94834134995bdc865d193412e44.png";